import React, { createContext } from 'react';
import { LinkAdapter } from './Link';

// get consumer context using 'useContext' hook
const LinkAdapterContext = createContext<LinkAdapter | null>(null);

export type LinkAdapterProviderProps = {
  /** linkAdapter injects the custom link component */
  linkAdapter: LinkAdapter;
};

const LinkAdapterProvider: React.FC<LinkAdapterProviderProps> & {
  Context: typeof LinkAdapterContext;
} = ({ linkAdapter, children }) => {
  return (
    <LinkAdapterContext.Provider value={linkAdapter}>
      {children}
    </LinkAdapterContext.Provider>
  );
};

LinkAdapterProvider.Context = LinkAdapterContext;

export default LinkAdapterProvider;
